import React from "react";
import { Route } from "react-router-dom";
import { useGlobal } from "GlobalContext";

import PrivacyPublic from "views/Privacy/PrivacyAlt";
import PrivacyPrivate from "views/Privacy/Privacy";

const PrivacyRoute = ({ ...rest }) => {
  const { sharedValue } = useGlobal();
  const isAuthenticated = Boolean(sharedValue.id);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <PrivacyPrivate {...props} />
        ) : (
          <PrivacyPublic {...props} />
        )
      }
    />
  );
};

export default PrivacyRoute;